import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";
import FormHelperText from "@mui/material/FormHelperText";

import { styled } from "@mui/material/styles";

export default function CustomSelect({
  fullWidth,
  label,
  multiple,
  value,
  handleChange,
  options,
  required,
  error,
  errorMessage,
}) {
  const CustomInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #7747c0",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      //   // Use the system font instead of the default Roboto font.
      //   fontFamily: [
      //     "-apple-system",
      //     "BlinkMacSystemFont",
      //     '"Segoe UI"',
      //     "Roboto",
      //     '"Helvetica Neue"',
      //     "Arial",
      //     "sans-serif",
      //     '"Apple Color Emoji"',
      //     '"Segoe UI Emoji"',
      //     '"Segoe UI Symbol"',
      //   ].join(","),
      "&:focus": {
        color: "#7747c0",
        borderRadius: 4,
        borderColor: "#f7b500",
        boxShadow: "#f7b500",
      },
    },
  }));

  return (
    <FormControl
      style={{ marginTop: 11 }}
      variant="filled"
      fullWidth={fullWidth}
      error={error}
    >
      <InputLabel required={required} htmlFor="demo-customized-textbox">
        {label}
      </InputLabel>
      <Select
        error={error}
        labelId="demo-simple-select-filled-label"
        id="demo-simple-select-filled"
        value={value}
        onChange={handleChange}
        input={<CustomInput />}
        multiple={multiple}
      >
        {options.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{errorMessage}</FormHelperText>
    </FormControl>
  );
}
